export default __webpack_public_path__ + "static/media/aboutimg7.0aaf770d.webp";